export default "__VITE_ASSET__hP1IHegk__"